import type { ReactElement } from 'react';
import type { FaceRenderNotice } from '../face-render/render-face';
import type { ViewableFace } from '../viewable-faces';

interface FaceNoticesProps {
  readonly kind: ViewableFace['kind'];
  readonly notices: readonly FaceRenderNotice[];
}

/** 면 종류 안내(V11) — 디자인을 넣을 수 있는 면에는 없다. */
const KIND_MESSAGES: Readonly<Record<ViewableFace['kind'], string | null>> = {
  design: null,
  empty: '이 면에는 인쇄 영역이 없어요',
};

/** 그리기 안내(V9·V12) — 글자·이미지를 빼지 않고 대체했다는 사실을 알린다. */
const NOTICE_MESSAGES: Readonly<Record<FaceRenderNotice, string>> = {
  FONT_FALLBACK: '일부 글꼴을 대체 글꼴로 보여 줘요',
  IMAGE_MISSING: '일부 이미지를 불러오지 못했어요',
};

/** 무대 아래 안내 줄 — 면 종류 안내와 그리기 안내를 함께 둔다. 안내가 없으면 그리지 않는다. */
export const FaceNotices = ({ kind, notices }: FaceNoticesProps): ReactElement | null => {
  const kindMessage = KIND_MESSAGES[kind];
  const messages = [
    ...(kindMessage === null ? [] : [kindMessage]),
    ...new Set(notices.map((notice) => NOTICE_MESSAGES[notice])),
  ];
  if (messages.length === 0) return null;

  return (
    <ul aria-label="미리보기 안내" className="flex flex-col gap-1 text-xs text-muted-foreground">
      {messages.map((message) => (
        <li key={message}>{message}</li>
      ))}
    </ul>
  );
};
